import { baseURL } from "../ApiConstant";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import apiClient from "../apiClient";


// get my subscriptions
export const getMySubscriptionService = async () => {
    try {
      const response = await apiClient.get(`/api/user/my-subscription-info`);
  
      if (response.status === 200) {
        return { status: true, body: response.data };
      } else {
        return { status: false, error: "failed" };
      }
    } catch (error: any) {
      // Handle error (display error message, log, etc.)
      return {
        status: false,
        error: "An error occurred. Please try again later.",
      };
    }
  };
  

  // get Payment History
export const getPaymentHistoryService = async () => {
    try {
      const response = await apiClient.get(`/api/user/payment-history`);
  
      if (response.status === 200) {
        return { status: true, body: response.data };
      } else {
        return { status: false, error: "failed" };
      }
    } catch (error: any) {
      // Handle error (display error message, log, etc.)
      return {
        status: false,
        error: "An error occurred. Please try again later.",
      };
    }
  };


  // create shop names
export const userResetPassword = async (
  current_password: string,
  new_password: string,
  new_confirm_password: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const user_id=localStorage.getItem('user_id');
    const FULL_TOKEN = `Bearer ${token}`;
 
    const response = await fetch(`${baseURL}/api/user/reset-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({user_id,current_password,new_password,new_confirm_password }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};
